import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Layout from './components/layout/Layout';
import LoginPage from './pages/Login';
import RegisterPage from './pages/Register';
import ForgetPasswordPage from './pages/ForgetPassword';
import AdminPlace from './pages/admin/AdminPlace';
import AdminCategory from './pages/admin/AdminCategory';
import AdminLocation from './pages/admin/AdminLocation';
import EditFoodPlace from './pages/admin/EditFoodPlace';
import EditLocation from './pages/admin/EditLocation';
import EditCategory from './pages/admin/EditCategory';
import { AuthProvider } from './contexts/AuthContext';
import { AlertProvider } from './contexts/AlertContext';

export const API_PATH = `${process.env.REACT_APP_API_URL}`;

const App = () => {
  useEffect(() => {});

  return (
    <Router>
      <AuthProvider>
        <AlertProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/admin-place" element={<AdminPlace />} />
              <Route path="/admin-category" element={<AdminCategory />} />
              <Route path="/admin-location" element={<AdminLocation />} />
              <Route path="/admin/place/:id" element={<EditFoodPlace />} />
              <Route path="/admin/location/:id" element={<EditLocation />} />
              <Route path="/admin/category/:id" element={<EditCategory />} />
              <Route path="/" element={<Home />} />
            </Route>
            <Route path="/Login" element={<LoginPage />} />
            <Route path="/Register" element={<RegisterPage />} />
            <Route path="/Forget-Password" element={<ForgetPasswordPage />} />
          </Routes>
        </AlertProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
